<!--系统菜单一览模块
创建人：lijt
时间：2017-08-04-->
<template>
	<div class="wrapper-content animated fadeInRight tabBox"  id="systemMenu-list">
			<div class="ibox-content" v-loading="loadingstatus">
				<div class="form-horizontal">
					<div class="form-group">
						<label class="col-sm-1 control-label">名称</label>
						<div class="col-sm-3">
							<input type="text" class="form-control menuInput" v-model="queryParams.name">
						</div>
						<label class="col-sm-1 control-label">父ID</label>
						<div class="col-sm-3">
							<input type="text" id="menuGroup_list" class="form-control menuInput" v-model="queryGroup"  @focus="showMenu" readonly>
							<div id="menuContentM" class="menuContent" style="display:none; position: absolute;">
								<ul id="menuGroupTree" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
							</div>
						</div>
						<label class="col-sm-1 control-label">类型</label>
						<div class="col-sm-3">
							<select class="form-control" v-model="queryParams.types">
								<option v-for="item in typeArray" :value="item.value">{{item.textName}}</option>
							</select>
						</div>
				</div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button type="button" class="btn btn-primary" @click="seachInfo">查询</button>
						<button type="button" class="btn btn-primary" @click="resetQueryParams">重置</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button type="button" class="btn btn-primary" @click="openMenuEdit('new')">新建</button>
					</div>
				</div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr>
							<th>CODE</th>
							<th>名称</th>
							<th>类型</th>
							<th>功能树显示</th>
							<th>URL</th>
							<th>权限</th>
							<th>依赖关系</th>
							<th>显示顺序</th>
							<th>是否选中</th>
							<th>是否启用</th>
							<th>图标</th>
							<th></th>
						</tr>
					</thead>
						<tbody>
							<tr v-for="(item,index) in menuList">
								<td>{{item.code}}</td>
								<td>{{item.name}}</td>
								<td>{{setTypeName(item.type)}}</td>
								<td>{{setShowTypeName(item.showType)}}</td>
								<td>{{item.url}}</td>
								<td>{{item.permission}}</td>
								<td>{{item.dependence}}</td>
								<td>{{item.orderNO}}</td>
								<td>{{item.checkOn}}</td>
								<td>{{item.isEnable==0?'未启用':'已启用' }}</td>
								<td>{{item.icon}}</td>
								<td class="text-center">
									<a @click="openMenuEdit('edit',index)">编辑&nbsp;</a>
									<a @click="removeData(index)">&nbsp;删除</a>
								</td>
							</tr>
						</tbody>
				</table>
			</div>
			<Pagination v-if="menuList.length>0" :pageInfo="pageInfo" v-on:getData="getParam"></Pagination>
			<sub-modal ref="modalMsg" size="small" title="提示">
					{{messageStr}}
					<div slot="footer">
						<button class="btn btn-primary" @click="closeModalMsg('modalMsg')">确定</button>
					</div>
			</sub-modal>
		<sub-modal ref="deleteMsg" size="small" title="提示">
				{{messageStr}}
				<div slot="footer">
					<button class="btn btn-primary" @click="deleteMenuData">确定</button>
				</div>
		</sub-modal>
		<sub-page
			:show="toShow" 
				:bigTitleMsg="bigTitleMsg" 
				v-on:cancel="closeSub"
				>
				<div slot="bodycontent">
					<page-system-menu-edit
						v-on:cancel="closeSub"
						:item="editMenu"
						:mode="type"
						:groupList="groupList"
						v-on:refData="refData"
						>
					</page-system-menu-edit>
				</div>
			
		</sub-page>
		</div>
</div>	
</template>

<script>
	import SubModal from 'components/common/SubModal'
	import SubPage from 'components/common/SubPage'
	import PageSystemMenuEdit from 'components/pages/systemmenu/PageSystemMenuEdit'
	import classlist from 'util/classlist'
	import Pagination from 'components/common/Pagination'
	import { OPERATE_EXCEPTION } from 'static/message'
	export default{
		name:'PageSystemMenuList',
		components:{
			SubModal,
			PageSystemMenuEdit,
			SubPage,
			Pagination
		},
		data(){
			return{
				toCheck:true,
				loadingstatus:false,
				pageInfo:{
					pageNum:1,
					pages:0,
					pageSize:null,
					total:null,
					isFirstPage:false,
					isLastPage:false,
				},
				queryGroup:'',
				queryParams:{
					types:[],
					name:'',
					parentId:0,
					page_index:1,
				},
				typeArray:[
					{value:1,textName:"菜单"},
					{value:2,textName:"功能"},
					{value:3,textName:"接口"},
					{value:4,textName:"前端组件"}
				],
				loadingstatus:false,
				menuList:[],
				toShow:null,
				editMenu:{},
				messageStr:'',
				type:0,
				lastIndex:null,
				setting: {
					data: {
						key: {
							name: "name"
						},
						simpleData: {
							enable: true,
							idKey: "menuId",
							pIdKey: "parentId"
						}
					},
					view: {
						dblClickExpand: false,
						selectedMulti: false,
						autoCancelSelected: true
					},
					callback: {
						onClick: this.onClick
					}
				},
				groupList:null,
				bigTitleMsg:null,
			}
		},
		beforeMount(){
			this.getGroupData();
		},
		methods:{
			showMenu(){
				this.queryParams.parentId=null;
				this.queryGroup='';
				let treeObj = $.fn.zTree.getZTreeObj("menuGroupTree");
					treeObj.cancelSelectedNode();
				$(".menuContent").slideDown("fast");
				$("body").bind("mousedown", this.onBodyDown);
			},
			onBodyDown(event){
				var self = this;
				if (!(event.target.id == "menuGroup_list" || event.target.id == "menuContentM" || $(event.target).parents(".menuContent").length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$(".menuContent").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			//z-tree 相关
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($("#menuGroupTree"), this.setting, this.groupList);
			},
			onClick(e,treeId,treeNode){//点击树节点
				this.queryParams.parentId= treeNode.menuId;
				this.queryGroup = treeNode.name;
			},
			//自动搜索
			seachInfo(){
				this.queryParams.page_index=1;
				this.getMenuData();
			},
			getParam:function(param){
				this.queryParams.page_index = param;
				this.getMenuData();
			},
			setShowTypeName(val){
				if(val===0){
					return '不显示';
				}else if(val=1){
					return '组织机构显示'
				}else if(val==2){
					return '权限组显示'
				}
			},
			setTypeName(val){
				if(val===1){
					return '菜单';
				}else if(val=2){
					return '功能'
				}else if(val==3){
					return '接口'
				}else if(val==4){
					return '前端组件'
				}
			},
			getMenuData(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT+'/system/menu',{params:this.queryParams})
				.then((res)=>{
					if(res.body.success){
						const{pageNum,pageSize,total,pages,isFirstPage,isLastPage}=res.body.data;
						this.menuList = res.body.data.list;
						this.pageInfo={
							pageNum:pageNum,
							pageSize:pageSize,
							total:total,
							pages:pages,
							isFirstPage:isFirstPage,
							isLastPage:isLastPage,
						}
					}else{
						this.messageStr=res.body.message;
						this.openModalMsg('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.messageStr=res.body.message;
					this.openModalMsg('modalMsg');
					this.loadingstatus=false;
				}).catch((res)=>{
					this.messageStr=OPERATE_EXCEPTION;
					this.openModalMsg('modalMsg');
					this.loadingstatus=false;
				})
			},
			getGroupData(){
				this.loadingstatus=true;
				this.queryParams.types='1,2'
				this.queryParams.parentId=null;
				this.$http.get(process.env.API_ROOT+'/system/menu',{params:this.queryParams})
				.then((res)=>{
					if(res.body.success){
						this.groupList = res.body.data;
						let tempNode={
							menuId:0,
							name:"根节点",
						};
						this.groupList.unshift(tempNode);
						this.groupList.map(item=>{
							item.icon=null;
						})
						this.treeInit();
					}else{
						this.messageStr=res.body.message;
						this.openModalMsg('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.messageStr=res.body.message;
					this.openModalMsg('modalMsg');
					this.loadingstatus=false;
				}).catch((res)=>{
					this.messageStr=res.body.message;
					this.openModalMsg('modalMsg');
					this.loadingstatus=false;
				})
				this.queryParams.types='';
			},
			openModalMsg(ref){
				this.$refs[ref].open();
			},
			closeModalMsg(ref){
				this.$refs[ref].close();
			},
			resetQueryParams(){
				this.queryParams={
					types:'',
					name:'',
					parentId:'',
					page_index:1,
				};
				this.queryGroup='';
			},
			closeSub(){
				this.toShow=false;
				this.editMenu={};
				classlist.toggleScroll('open','#systemMenu-list',this);
			},
			openSub(){
				this.toShow=true;
				classlist.toggleScroll('close','#systemMenu-list',this);
			},
			openMenuEdit(type,index){
				this.lastIndex=index;
				if(type=='new'){
					this.editMenu={};
					this.editMenu.type=false;
					this.type=0;
					this.bigTitleMsg='新建菜单'
				}else if(type=='edit'){
					this.bigTitleMsg='编辑菜单'
					this.editMenu=this.menuList[this.lastIndex];
					this.type=1;
				}
				this.openSub();
			},
			removeData(index){
				this.lastIndex=index;
				this.messageStr="是否确定要删除此菜单";
				this.openModalMsg('deleteMsg');
			},
			deleteMenuData(){
				this.closeModalMsg('deleteMsg');
				this.loadingstatus=true;
				this.$http.delete(process.env.API_ROOT+'/system/menu/'+this.menuList[this.lastIndex].menuId)
				.then((res)=>{
						if(res.body.success){
							this.resetQueryParams();
							this.getMenuData();
						}else{
							this.messageStr=res.body.message;
							this.openModalMsg('modalMsg');
						}
						this.loadingstatus=false
					},(res)=>{
						this.messageStr=res.body.message;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false
					}
				).catch((res)=>{
						this.messageStr=OPERATE_EXCEPTION;
						this.openModalMsg('modalMsg');
						this.loadingstatus=false
				})
			},
			refData(){
				this.getMenuData();
			}
		}
	}
</script>

<style>
	.menuInput {
		position: relative;
	}
	
	.menuContent {
		position: absolute;
		top: 31px;
		left: 6px;
		border: 1px solid #ddd;
		z-index: 999;
	}
</style>


// WEBPACK FOOTER //
// PageSystemMenuList.vue?015c5fda